import { Fragment } from 'react';

import { actionUrl } from 'config/static-content';
import { NsAnchor } from 'components/common/ns-anchor/NsAnchor';
import { NsList } from 'components/common/ns-list/NsList';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';

export const testId = 'importantInformationTesId';

type ImportantInformationProps = {
  termsAndConditions: string;
};

export const ImportantInformation = ({
  termsAndConditions
}: ImportantInformationProps) => {
  const handlePrint = (event) => {
    event.preventDefault();
    window.print();
  };
  return (
    <div data-testid={testId}>
      <h3>Important information</h3>
      <NsList>
        {[
          <Fragment key={0}>
            This tariff may no longer be available to sign up to and is included
            for reference purpose only. See our{' '}
            <NsAnchor
              target={undefined}
              rel={undefined}
              href={actionUrl.bgSalesApp}
            >
              current energy tariffs here
            </NsAnchor>
            .
          </Fragment>,
          <Fragment key={1}>
            Read the{' '}
            <NsAnchor href={termsAndConditions} id="tariffTermsLink">
              tariff terms and conditions
            </NsAnchor>{' '}
            for your records.
          </Fragment>,
          <Fragment key={2}>
            <NsSecondaryCta icon="" onClick={handlePrint}>
              Print this page
            </NsSecondaryCta>{' '}
            for your records.
          </Fragment>,
          <Fragment key={3}>
            Prices include VAT at the applicable rate and are rounded. The
            prices appear differently on your bills and statements where we show
            prices excluding VAT. To find out more go to{' '}
            <NsAnchor href="https://www.britishgas.co.uk/aem6/content/dam/britishgas/documents/calculating-bills.pdf">
              www.britishgas.co.uk/calculatingbills
            </NsAnchor>
          </Fragment>,
          ` These prices apply to customers using mains gas and to customers using
          piped propane in Llanfyllin, Llanwrtyd Wells, Colden and Stornoway.`
        ]}
      </NsList>
    </div>
  );
};
